module.exports = __webpack_public_path__ + "img/paymentSuccessful.2c77d081.svg";